import styled from 'styled-components';

export const NameColumnContainer = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  text-wrap: nowrap;
`;
